export const GET_MERCHANTS_REQUESTED =
  'GET_MERCHANTS_REQUESTED'
export const GET_MERCHANTS_SUCCEEDED =
  'GET_MERCHANTS_SUCCEEDED'
export const GET_MERCHANTS_FAILED =
  'GET_MERCHANTS_FAILED'

export const UPDATE_MERCHANTS_REQUESTED =
  'UPDATE_MERCHANTS_REQUESTED'
export const UPDATE_MERCHANTS_SUCCEEDED =
  'UPDATE_MERCHANTS_SUCCEEDED'
export const UPDATE_MERCHANTS_FAILED =
  'UPDATE_MERCHANTS_FAILED'

export const CREATE_MERCHANTS_REQUESTED =
  'CREATE_MERCHANTS_REQUESTED'
export const CREATE_MERCHANTS_SUCCEEDED =
  'CREATE_MERCHANTS_SUCCEEDED'
export const CREATE_MERCHANTS_FAILED =
  'CREATE_MERCHANTS_FAILED'

export const DELETE_MERCHANTS_REQUESTED =
  'DELETE_MERCHANTS_REQUESTED'
export const DELETE_MERCHANTS_SUCCEEDED =
  'DELETE_MERCHANTS_SUCCEEDED'
export const DELETE_MERCHANTS_FAILED =
  'DELETE_MERCHANTS_FAILED'

export const SEARCH_MERCHANTS =
  'SEARCH_MERCHANTS'
